import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import {GaTrackingEventLabel, GaTrackingEventName, GATrackingEventType} from '../../constants';

export class GATrackingLogoutEvent implements GATrackingEvent {

  getEventType(): GATrackingEventType {
    return GATrackingEventType.LogoutClick;
  }

  getPayload(): GATrackingEventPayload {
    return {
      event: GaTrackingEventName.Logout,
      label: GaTrackingEventLabel.LogoutClick
    };
  }
}
